export default "__VITE_ASSET__BEl_fgDA__"